export default "__VITE_ASSET__DCKstIby__"